import { SaveButton } from "components/Buttons"
import ColorPicker from "components/ColorPicker"
import { CustomImageField, TextField } from "components/RenderInput"
import { FORM_NAMES, LOCAL_STORAGE_TAGS } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardImg, Col, Row } from "reactstrap"
import { change, Field, formValueSelector, getFormSyncErrors } from "redux-form"
import { updateClientEmailConfig, updateClientSettings } from "store/actions"
import {
  emailVaildation,
  fieldLevelValidation,
  mapEmailSettingsToApi,
} from "../utils"

const EmailSettingsTab = ({
  logoImage,
  vendorConfig,
  updateClientSettings,
  updateClientEmailConfig,
  change,
  formValues,
  formSyncErrors,
  vendorId,
}) => {
  const api_token = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER)
  ).api_token

  const saveHandler = () => {
    if (!formSyncErrors.hasOwnProperty("emailSettings_setup")) {
      const [emailConfig, config] = mapEmailSettingsToApi({
        ...formValues,
        vendor_id: vendorId,
        api_token: api_token,
      })
      updateClientEmailConfig(emailConfig)
      updateClientSettings({
        params: {
          ...vendorConfig,
          ...config,
        },
      })
    }
  }
  return (
    <React.Fragment>
      <Row className="my-3">
        <Col>
          <Card>
            <CardBody>
              <Row className="my-3">
                <Col xs={6}>
                  <Row>
                    <Col xs={12}>
                      <label>Logo image</label>
                    </Col>
                    <Col xs={12}>
                      <Field
                        name="logoImage"
                        component={CustomImageField}
                        onDelete={() => {
                          change("emailSettings_setup.deleteImage", 1)
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col className="d-flex justify-content-end">
                  {logoImage && logoImage?.editedImage && (
                    <CardImg
                      src={logoImage?.editedImage ? logoImage?.editedImage : ""}
                      alt="image"
                      className="rounded avatar-xl"
                    />
                  )}
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="appName"
                    label="App Name"
                    validate={fieldLevelValidation}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="appStoreURL"
                    label="Apple Store URL"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="appleStoreDevAcc"
                    label="Apple Store Developer Account Name                    "
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="googleStoreURL"
                    label="Google Store URL"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="googleStoreDevAcc"
                    label="Google Store Developer Account Name                    "
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field component={ColorPicker} name="color" label="Color" />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="contactUsEmail"
                    label="Contact Us Email"
                    validate={[fieldLevelValidation, emailVaildation]}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="fromName"
                    label="From Name"
                    validate={fieldLevelValidation}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="fromEmail"
                    label="From Email"
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <h5>SendGrid Email Templates IDS:</h5>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p>
                    <i>
                      If a template is not filled in, those emails will not be
                      sent.
                    </i>
                  </p>
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="appInvite"
                    label="App Invite with Temp Password"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="booking"
                    label="Booking (confirm, notify before start, notify cancelled)"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="bookingPayment"
                    label="Booking Payment (success/failed, refunding, refund success)"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="customEmail"
                    label="Custom email"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="experienceInvite"
                    label="Experience invite"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="experienceReminder"
                    label="Experience reminder"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="formBuilderPayment"
                    label="Form Builder Payment (success/failed, refunding, refund success)"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="orderPayment"
                    label="Order Payment (success/failed, refunding, refund success)"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="referFriend"
                    label="Refer a Friend"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="referrer"
                    label="Referrer"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="rsvp"
                    label="RSVP created/updated - sent to guest and host"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="visitorRegistered"
                    label="Visitor Registered"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="visitorRegisteredTentant"
                    label="Visitor Registered Tenant"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="welcomeUser"
                    label="Welcome User (sent when account created)"
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col>
                  <Field
                    component={TextField}
                    name="surveyFormBuilder"
                    label="Survey/Form Builder filled out copy (sent to user and selected admins)"
                  />
                </Col>
              </Row>
              <Row className="my-3 justify-content-center">
                <Col xl={1}>
                  <SaveButton
                    type="button"
                    content="Save"
                    onClick={saveHandler}
                    fullWidth={true}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.VENDOR_FEATURES)

const mapStateToProps = state => ({
  logoImage: selector(state, "emailSettings_setup.logoImage"),
  vendorEmailConfig: state.clients.vendorEmailConfig,
  vendorConfig: state.clients.vendorConfig,
  formValues: selector(state, "emailSettings_setup"),
  formSyncErrors: getFormSyncErrors(FORM_NAMES.VENDOR_FEATURES)(state),
})

const mapDispatchToProps = dispatch => ({
  updateClientEmailConfig: values => dispatch(updateClientEmailConfig(values)),
  updateClientSettings: values => dispatch(updateClientSettings(values)),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.VENDOR_FEATURES, `${field}`, value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EmailSettingsTab)
